export default __webpack_public_path__ + "static/media/Snd_BigLineDownCorner.54d7dfaa.mp3";